import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { QuoteButton } from './QuoteModal';

const SectionCTA = ({
  eyebrow = 'Ready when you are',
  title = 'GET REAL RESULTS',
  titleItalic,
  subtitle,
  ctaLabel = 'GET A QUOTE',
  phone = '1800 006 296',
  variant = 'dark',
}) => {
  const isDark = variant === 'dark';
  return (
    <section
      className={`relative overflow-hidden py-20 md:py-28 ${
        isDark ? 'bg-slate-900 text-white' : 'bg-[#f8fafc] text-slate-900'
      }`}
      data-testid="section-cta"
    >
      {isDark && (
        <>
          <div className="pointer-events-none absolute -top-20 left-10 h-72 w-72 rounded-full bg-[#15803d]/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 right-10 h-80 w-80 rounded-full bg-[#db2777]/20 blur-3xl" />
        </>
      )}
      <div className="container relative z-10 mx-auto px-6 md:px-12 max-w-5xl text-center">
        {eyebrow && (
          <p
            className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] mb-6 ${
              isDark ? 'bg-white/10 text-[#86efac]' : 'bg-[#15803d]/10 text-[#166534]'
            }`}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#15803d]" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-[\'Outfit\'] text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] mb-6">
          {title}
          {titleItalic && (
            <>
              {' '}
              <span className="italic font-serif font-medium text-[#15803d]">{titleItalic}</span>
            </>
          )}
        </h2>
        {subtitle && (
          <p
            className={`text-lg md:text-xl max-w-3xl mx-auto mb-10 leading-relaxed ${
              isDark ? 'text-slate-300' : 'text-slate-600'
            }`}
          >
            {subtitle}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <QuoteButton
            data-testid="section-cta-button"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#db2777] hover:bg-[#be185d] text-white px-10 py-5 font-bold text-lg shadow-xl shadow-[#db2777]/30 transition-all hover:-translate-y-0.5 hover:shadow-2xl"
          >
            {ctaLabel}
            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
          </QuoteButton>
          <a
            href={`tel:${phone.replace(/\s+/g, '')}`}
            className={`inline-flex items-center justify-center gap-2 rounded-full border-2 px-10 py-5 font-bold text-lg transition-all hover:-translate-y-0.5 ${
              isDark
                ? 'border-white/30 text-white hover:border-white hover:bg-white/10'
                : 'border-slate-300 text-slate-900 hover:border-[#15803d] hover:text-[#15803d]'
            }`}
          >
            <Phone size={18} /> {phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default SectionCTA;
